// extracted by mini-css-extract-plugin
module.exports = {"indicator-block":"indicator-block___yFB-R","values":"values___1H2fL","value":"value___aqPxQ","label":"label___1WGOK"};